import { createRouter, createWebHistory } from "vue-router";
import AgentLogin from "@/pages/AgentLogin.vue";
import AgentInbox from "@/pages/AgentInbox.vue";
import ManagerDashboard from "@/pages/ManagerDashboard.vue";
import ManagerFlows from "@/pages/ManagerFlows.vue";


export default createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: AgentLogin },
    { path: "/inbox", component: AgentInbox },
    { path: "/manager", component: ManagerDashboard },
    { path: "/manager/flows", component: ManagerFlows },
    { path: "/manager/flows/:id/designer", component: () => import("@/pages/ManagerFlowDesigner.vue") }

  ],
});